<template>
  <div class="content">
    <el-form
      class="form"
      :model="ruleForm"
      ref="form"
      label-width="110px"
      label-position="right"
      :rules="rules"
      :disabled="formDisabled"
    >
      <el-form-item label="标题" prop="title">
        <el-input placeholder="请填写标题" v-model="ruleForm.title"></el-input>
      </el-form-item>
      <el-form-item label="副标题" prop="subtitle">
        <el-input placeholder="请填写副标题" v-model="ruleForm.subtitle"></el-input>
      </el-form-item>
      <el-form-item label="时间" prop="publishedTime">
        <el-date-picker
          v-model="ruleForm.publishedTime"
          type="date"
          placeholder="选择日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          clearable
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="所属年度" prop="year">
        <el-date-picker
          v-model="ruleForm.year"
          type="year"
          format="yyyy"
          value-format="yyyy"
          placeholder="选择年度"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="类型" prop="policyType">
        <el-select v-model="ruleForm.policyType" clearable placeholder="请选择类型">
          <el-option
            v-for="item in levelOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="新闻内容" prop="policyInfo">
        <editor
          refName="policyInfo"
          :placeholderText="'请填写新闻内容'"
          v-model="ruleForm.policyInfo"
          :upload-url="uploadURL"
          :img-show-url="imgUrl"
          :disabled="formDisabled"
        ></editor>
      </el-form-item>
      <el-form-item label="发布" prop="publishedFlag">
        <el-switch v-model="ruleForm.publishedFlag" active-text="是" inactive-text="否"></el-switch>
      </el-form-item>
    </el-form>
  </div>
</template>

<script type="text/ecmascript-6">
import editor from "@/components/tinymce-editor/tinymce-editor";
export default {
  props: ['formDisabled', 'messageId'],
  components: {
		editor,
	},
  data() {
    return{
      levelOptions: [{
					value: 1,
					label: "市级",
				},
				{
					value: 2,
					label: "省级",
				},
        {
					value: 3,
					label: "国家级",
				}
			],
      ruleForm: {
        title: '', // 政策法规标题
        subtitle: '', // 政策法规副标题
        publishedTime: '', // 发布时间
        year: '', // 所属年度
        policyType: 1, // 政策类型：1市级, 2省级, 3国家级,示例值(1)
        policyInfo: '', // 政策信息
        publishedFlag: false // 是否发布
      },
      rules: {
				title: [{
					required: true,
					message: "请填写标题",
					trigger: "blur"
				}, ],
				publishedTime: [{
					required: true,
					message: "请选择日期",
					trigger: "change"
				}, ],
				year: [{
					required: true,
					message: "请选择年度",
					trigger: "change"
				}, ],
				type: [{
					required: true,
					message: "请选择类型",
					trigger: "change"
				}, ],
				content: [{
					required: true,
					message: "请输入新闻内容",
					trigger: "blur"
				}],
				introduction: [{
					required: true,
					message: "请输入众创空间简介",
					trigger: "blur"
				}, ],

				standard: [{
					required: true,
					message: "请输入服务介绍与收费标准",
					trigger: "blur",
				}, ],
			},
    }
  },
  methods: {
    initDate(id) {
      this.http.get(`${this.urlConfig.devUrl}apij2/admin-api/finance/policy-regulation/get?id=${id}`)
        .then((res) => {
          if (res.code == 0) {
            this.ruleForm = {
              ...res.data
            }
            this.ruleForm.publishedFlag = Boolean(res.data.publishedFlag);
            this.ruleForm.year = res.data.year + '';
          } else {
            this.$message({
              message: "失败！",
              type: "error",
            });
          }
        });
    },
    parentHandleclick(e) {
      this.$refs.form.validate((val) => {
        if (val) {
          const params = {
            ...this.ruleForm,
            publishedFlag: this.ruleForm.publishedFlag ? 1 : 0
          }
          e && e(params);
        }
      });
    }
  },
  created() {
    if(this.messageId) {
      this.initDate(this.messageId)
    }
  }
}
</script>

<style scoped lang="scss">
.content {
  /deep/ {
    .el-input,
    .el-select {
      width: 100%;
    }
  }
}
</style>
